
import { call, put, takeEvery } from "redux-saga/effects";
import { message } from 'antd';
import captcha from "../Actions/captcha";
import { validateCaptchaRequest } from '../Api/Captcha';
const { VALIDATE_CAPTCHA } = captcha.types;
const { updateCaptcha } = captcha.actions;

export function* validateCaptcha ({siteKey}) {    
    try{
        const formData = new FormData();
        formData.append('gRecaptchaResponse', siteKey)
        const response = yield call(validateCaptchaRequest, formData);
        if(response !== null){            
            yield put(updateCaptcha(response));            
        }
    }catch(error){
        message.error(error.message, 5);
    }
}


export function* captchaSaga() {
    yield takeEvery(VALIDATE_CAPTCHA, validateCaptcha);    
}
